import { ModalBody, ModalTitle } from '@strava/ui/Modal';
import React from 'react';

const SuggestedFriends = () => {
  return (
    <>
      <ModalTitle id="onboarding-step-title">suggested_friends</ModalTitle>
      <ModalBody>SuggestedFriends</ModalBody>
    </>
  );
};

export default SuggestedFriends;
